import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import { ThemeContext } from 'styled-components';


const PortalComunicacao = ({ image, title , subTitle, link }) => {
  const theme = useContext(ThemeContext);

  const handleButtonClick = () => {
    window.location.href = link;
    // window.open(link, '_blank'); ABA NOVA
  };

  const styleContainer = {
    padding: '12px 24px',
    height: '144px',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    boxSizing: 'border-box',
  }

  const styleContainerImage = {
    maxHeight: '118.48px',
    maxWidth: '142.48px',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    paddingRight: '24px',
  }

  const styleCircle = {
    height: '118.48px',
    width: '118.48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: theme.action,
    boxSizing: 'border-box',
  }

  const styleContainerInformation = {
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    width: 'calc(100% - 142.48px)'
  }

  const styleTitle = {
    fontFamily: 'Public Sans',
    fontSize: '24px',
    fontWeight: 600,
    color: theme.primary,
    marginBottom: '8px',
    width: '100%'
  }

  const styleSubTitle = {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 400,
  }

  const styleButton = {
    padding: '8px 16px',
    borderRadius: '24px',
    color: '#fff',
    backgroundColor: theme.primary,
    fontFamily: 'Public Sans',
    fontSize: '16px',
    fontWeight: '700',
    textAlign: 'center',
    border: 'none',
    marginTop: "8px",
    position:'absolute'
  }

  const styleContainerButton = {
    display: 'flex',
    justifyContent: 'right',
    height: '100%',
    alignItems: 'flex-end'
  }

  return (
    <Grid style={{ boxSizing: 'border-box' }} item xs={12} sm={6}>
      <Grid container style={styleContainer} justifyContent="space-between">
        <Grid style={styleContainerImage} item >
          <Grid item style={styleCircle}>
            <Grid style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} item xs={12}>
              {image}
            </Grid>
          </Grid>
        </Grid>
        <Grid style={styleContainerInformation} >
          <Grid item style={styleTitle}>{title}</Grid>
          <Grid item style={styleSubTitle}>{subTitle}</Grid>
          <Grid item style={styleContainerButton}><button onClick={handleButtonClick} style={styleButton}>Acessar</button></Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default PortalComunicacao;
